import { useMemo } from 'react';

import { Pagination } from '@state/types';

export const getBorderElements = ({ totalCount, currentPage, pageSize }: Pagination) => {
  const totalPageCount = Math.ceil(totalCount / pageSize);
  const firstElement = currentPage * pageSize;

  let lastElement = (currentPage + 1) * pageSize - 1;
  if (lastElement >= totalCount) {
    lastElement = totalCount - 1;
  }

  return {
    totalPageCount,
    firstElement,
    lastElement
  };
};

export const usePagination = ({ totalCount, currentPage, pageSize }: Pagination) => {
  return useMemo(() => {
    return getBorderElements({ totalCount, currentPage, pageSize });
  }, [totalCount, currentPage, pageSize]);
};
